module.exports = __webpack_public_path__ + "static/media/habb.c161a7de.png";